<template>
    <div>
        <v-row class="no-spacing" style="background-color: 'transparent'">
            <v-col class="no-spacing">
                <v-spacer class="row-space-30"></v-spacer>
                <Steps :activeStep="sort" :profileSteps="profileSteps" class="centre-aligned"/>
                <v-spacer class="row-space-40"></v-spacer>  
            </v-col>
        </v-row>
        <router-view ref="child"></router-view>
    </div>
</template>
<script>
import Steps from "./ProfileProgressComponent";

export default {
    props: {
        sectionCount: Number
    },
    components: {
        Steps,
    },
    data: function() {
        return {
            sort: null,
            sections: [],
            profileSteps:{
                1: "My Details",
                2: "",
                3: "My Heritage",
                4: "",
                5: "My School",
                6: "",
                7: "My Family"
            }             
        }
    },
    methods: {
        validate() {
            return this.$refs.child.$refs.form.validate();
        },
        submit() {
            return this.$refs.child.submit();
        }
    },
    watch: {
        '$route.meta.sort': function (sort) {
            this.sort = sort
        }
    },
    mounted: function() {
        this.sort = this.$route.meta.sort;

        for (let i = 0; i < this.sectionCount; i++) {
            this.sections[i] = { sort: i + 1 };
        }
    }
}
</script>
<style lang="scss">
.title-wrapper {
    text-align: center;
    width: 100%;
    color: $go-dark-grey;
    margin-bottom: 10px;
}

.no-spacing
{
    margin: 0;
    padding: 0
}

.centre-aligned
{
    margin:auto;
}

.row-space-40
{
    height: 40px;
}

.row-space-30
{
    height: 30px
}
</style>
